module.exports = __webpack_public_path__ + "static/dana-photo-square-e35877c40967188af1b48ebb684f1418.jpg";